
export const config = {
    apiUrl: 'https://techmeet.ath.swisstiming.com/api/',
    sceneUrl: 'https://techmeet.origin.ath.swisstiming.com/pscb.html',
    frontegg: {
        baseUrl: 'https://swisstiming.frontegg.com',
        tenantId: 'ed514594-89ab-4fa2-a5d2-f6c08e0c76d4',
        clientId: '2e1abb99-4c76-4704-8e6c-a8390b47c079'
    }
};